'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

/**
 * Minimal NeighborhoodProvider for HALO.
 *
 * The legacy NeighborhoodProvider wraps a singleton state manager that tracks
 * commute destination, POI activations, view mode, etc. across instances. In
 * vercel, that state is already kept in React Query + localStorage (see
 * `@/src/lib/hooks/neighborhood`), so HALO's provider is a thin pass-through
 * whose only job is to mark that "there is a neighborhood context" for
 * `useNeighborhoodContextSafe` consumers that want to detect nesting.
 */

type NeighborhoodContextValue = {
  present: true;
};

const NeighborhoodContext = createContext<NeighborhoodContextValue | null>(null);

export const NeighborhoodProvider = ({ children }: { children: ReactNode }) => (
  <NeighborhoodContext.Provider value={{ present: true }}>{children}</NeighborhoodContext.Provider>
);

export const useNeighborhoodContextSafe = () => useContext(NeighborhoodContext);
